import { makeStyles, createStyles } from '@material-ui/core/styles';

export default makeStyles(
  ({ zIndex }) =>
    createStyles({
      listButtonClass: {
        '& > .hst-fab': {
          top: '5px !important',
          right: '5px',
        },
      },
      sectionButtonClass: {
        position: 'relative',
        '& > .hst-fab': {
          top: '-20px !important',
          right: '-5px',
        },
      },
      contentButtonClass: {
        position: 'absolute',
        top: 0,
        right: 0,
        '& > .hst-fab': {
          top: '5px !important',
          right: '5px',
        },
      },
    }),
  { name: 'GenGlobalHeaderContainer' },
);
